// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container for major services */
.major-services-container {
  text-align: center;
  background-color: #3fa9c3;
  color: white;
  padding: 20px;
}
.major-services-container h2{
  color: white;
  font-size: 30px;
}
/* Wrapper for all service sections */
.major-services {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

/* Individual service sections */
.major-services-section {
  width: 45%;
}

/* Service section headings */
.major-services-section h3 {
  padding-bottom: 10px;
  font-size:30px;
  margin-left: -75%;
}

/* Unordered list of services */
.major-services-section ul {
  list-style-type: disc;
  padding-left: 20px;
  text-align: left;
  font-size: 20px;
}

/* List items */
.major-services-section li {
  margin: 5px 0;
}

/* Mobile view adjustments */
@media (max-width: 768px) {
  .major-services {
    flex-direction: column; /* Stack the sections vertically */
    align-items: center; /* Center align items */
  }

  .major-services-section {
    width: 90%; /* Make each section take most of the width */
    margin-bottom: 20px; /* Add space between sections */
  }

  .major-services-section h3 {
    margin-left: 0; /* Reset left margin for better alignment */
    text-align: center; /* Center the heading */
  }

  .major-services-section ul {
    padding-left: 15px; /* Reduce padding for smaller screens */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MajorServices/MajorServices.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE;IACE,sBAAsB,EAAE,kCAAkC;IAC1D,mBAAmB,EAAE,uBAAuB;EAC9C;;EAEA;IACE,UAAU,EAAE,6CAA6C;IACzD,mBAAmB,EAAE,+BAA+B;EACtD;;EAEA;IACE,cAAc,EAAE,2CAA2C;IAC3D,kBAAkB,EAAE,uBAAuB;EAC7C;;EAEA;IACE,kBAAkB,EAAE,uCAAuC;EAC7D;AACF","sourcesContent":["/* Main container for major services */\n.major-services-container {\n  text-align: center;\n  background-color: #3fa9c3;\n  color: white;\n  padding: 20px;\n}\n.major-services-container h2{\n  color: white;\n  font-size: 30px;\n}\n/* Wrapper for all service sections */\n.major-services {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 20px;\n}\n\n/* Individual service sections */\n.major-services-section {\n  width: 45%;\n}\n\n/* Service section headings */\n.major-services-section h3 {\n  padding-bottom: 10px;\n  font-size:30px;\n  margin-left: -75%;\n}\n\n/* Unordered list of services */\n.major-services-section ul {\n  list-style-type: disc;\n  padding-left: 20px;\n  text-align: left;\n  font-size: 20px;\n}\n\n/* List items */\n.major-services-section li {\n  margin: 5px 0;\n}\n\n/* Mobile view adjustments */\n@media (max-width: 768px) {\n  .major-services {\n    flex-direction: column; /* Stack the sections vertically */\n    align-items: center; /* Center align items */\n  }\n\n  .major-services-section {\n    width: 90%; /* Make each section take most of the width */\n    margin-bottom: 20px; /* Add space between sections */\n  }\n\n  .major-services-section h3 {\n    margin-left: 0; /* Reset left margin for better alignment */\n    text-align: center; /* Center the heading */\n  }\n\n  .major-services-section ul {\n    padding-left: 15px; /* Reduce padding for smaller screens */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
